import { endpoints } from '../helper/endpoints';
import jwtInterceptor from '../helper/jtwInterceptor';
import { RecordState } from '../helper/recordState';
import {
	QuoteGroupResponse,
	Quote,
	QuoteCreateRequest,
	Product,
	Package,
	QuoteProduct,
} from '../shared/types/quotes';
import { RegionData, regionDataRowsToQuoteRatingRegions } from '../shared/types/regionData';

// Not sure if this method is still needed
// export const getQuotes = async () => {
//   try {
//     const data = await jwtInterceptor({
//       method: "post",
//       url: "https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/quote-get-quotes",
//     });
//     return data;
//   } catch (error: any) {
//     throw new Error(error);
//   }
// };

/**
 * Function to generate a quote object based on the provided data.
 * @param {any} item - The item containing quote data.
 * @param {any} values - (Optional) Additional values for generating the quote object.
 * @returns {Object} The generated quote object.
 */
export const generateQuoteObject = (
	item: Product | Package,
	values: any,
	ratingRegionsRows: RegionData[]
): QuoteCreateRequest => {
	let tempProducts: any[] = [];
	let tempPackages: any[] = [];

	if ('products' in item) {
		// console.log("I'm a package", item);
		tempPackages.push({
			id: item.id,
			name: item.name,
			quoteProducts: item.products.map((product) => generateProduct(product)),
		});
	} else {
		tempProducts.push(generateProduct(item));
	}

	const quoteRatingRegions = regionDataRowsToQuoteRatingRegions(ratingRegionsRows).filter(
		(reg) => reg.staffNumbers > 0 || reg.currentYearAmount > 0 || reg.lastYearAmount > 0
	);

	return {
		id: 0,
		policyId: 0,
		readOnly: false,
		RecordState: RecordState.New,
		brokeragePercentage: 20,
		// totalTurnoverAmountLastYear: null,
		// totalTurnoverAmountCurrentYear: null,
		// totalStaffNumbers: null,
		quoteRatingRegions,
		quoteProducts: tempProducts,
		quotePackages: tempPackages,
	};
};

/**
 * Function to generate a product object based on the provided data.
 * @param {any} product - The product data.
 * @returns {Object} The generated product object.
 */
export const generateProduct = (product: Product | QuoteProduct): QuoteProduct => {
	console.log('Product in generateProduct', product);
	const productSections =
		'quoteProductSections' in product ? product.quoteProductSections : product.productSections;

	if (
		'quoteProductSections' in product &&
		product.quoteProductSections.every((section: any) => !Array.isArray(section.liability))
	) {
		return product;
	}
	return {
		id: product.id,
		quoteLineId: 0,
		name: product.name,
        referralReasons: [],
		quoteProductSections: productSections.map((q: any) => {
			//TODO: ----------
			//Vadim: This is a code duplication of the same logic in components/QuoteSummaryProducts/index.tsx/productLimits function and should be replaced with common function
			let liabilityValue;
			// Check if the product id is Product Recall and the liability array has 2 or more elements
			if (
				(product.id === 109 || product.id === 110) &&
				Array.isArray(q.liability) &&
				q.liability.length >= 2
			) {
				// Select the second element of the liability array
				liabilityValue = q.liability[1];
			} else {
				// Default behavior for other cases
				liabilityValue = Array.isArray(q.liability) ? q.liability[0] : q.liability;
			}
			//--------------

			return {
				id: 0,
				productSectionId: q.id,
				productSectionName: product.name,
				//liability: Array.isArray(q.liability) ? q.liability[0] : q.liability,
				liability: liabilityValue,
				excess: Array.isArray(q.excess) ? q.excess[0] : q.excess,
				premium: q.premium ?? null,
				quoteRatingParameters: [],
			};
		}),
	};
};

/**
 * Function to get a quote group by its ID.
 * @param {any} quoteId - The ID of the quote group to retrieve.
 * @returns {Promise} A Promise that resolves with the quote group data if successful, or rejects if an error occurs.
 */
export const getQuoteGroup = async (quoteId: any): Promise<QuoteGroupResponse> => {
	try {
		const quote = await jwtInterceptor.post(
			endpoints.GET_QUOTE_GROUP_BY_QUOTE_ID,
			// const data = await jwtInterceptor.post("https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/quote-quote-groups-by-group-id",
			quoteId,
			{
				headers: {
					'Content-Type': 'application/json',
				},
			}
		);
		// Return the quote data.
		return quote.data;
	} catch (error: any) {
		console.log(`Error getting quote group ${quoteId}`, error);
		throw new Error(error);
	}
};
